let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ldW3y")).then(() => parcelRequire('iJVce'));